module.exports = __webpack_public_path__ + "img/bg-106.3dc26ca8.jpg";